import { call, put, takeLatest } from "redux-saga/effects";
import apiService from "services/apiservice";
import { getErrorMessageString } from "utils/utils";
import { notificationController } from "components/common/notificationController";
import { loadState } from "library/helpers/sessionStorage";
import {
  downloadActivityFileFailure,
  downloadActivityFileSuccess,
  fetchActivityListFailure,
  fetchActivityListSuccess,
} from "./actions";
import {
  FETCH_ACTIVITY_LIST_REQUEST,
  DOWNLOAD_ACTIVITY_FILE_REQUEST,
} from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const config = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
};

const getRequestForDownload = async (url: string, configVal: any) => {
  const data = await apiService.get(url, configVal);
  return data;
};

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, config);
  return data;
};

function* fetchActivityListSaga(action: any) {
  try {
    const response: { status: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );

    yield put(fetchActivityListSuccess(response));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching activity list: ${errorMessage}`,
      });
    }
    yield put(fetchActivityListFailure(errorMessage));
  }
}

function* downloadActivityFileSaga(action: any) {
  try {
    let fileName = action.payload.fileName
    const response: { data: any; headers: any } = yield call(
      getRequestForDownload,
      action.url,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName.substring(fileName.lastIndexOf("/") + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    yield put(downloadActivityFileSuccess(response));
    action.callback("Success", "", {
      ...response,
      fileName: action?.payload?.fileName,
    });
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(downloadActivityFileFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* activitySagas() {
  yield takeLatest(FETCH_ACTIVITY_LIST_REQUEST, fetchActivityListSaga);
  yield takeLatest(DOWNLOAD_ACTIVITY_FILE_REQUEST, downloadActivityFileSaga);
}
